import { track } from 'src/tracking/analytics';

export const trackButtonClick = ({ button, location }) =>
  track(`Referrals: button click - FE`, { location, button });
